import React from "react";
import MdiIcon from "./MdiIcon";
import { deviceColors, deviceIcon } from "./deviceTheme";
import TimeAgo from "../../../helpers/TimeAgo";

// Web version of the mobile app's device card (app/components/SwitchComponent.js).
// It is white while inactive; when active, a gradient in the device type's
// colours grows from behind the icon to fill the card and the text turns white.
// alwaysColoured keeps that colour showing whatever the state, for the cards the
// app always colours. type is the lower-cased deviceType; iconActive and
// colorActive are the flags the app passes to its icon and colour tables.
//
// As in the app, a card with onToggle switches the device from its icon half
// and opens the details from its name half; without onToggle the whole card
// opens the details.
const AppDeviceCard = ({
  name,
  floor,
  room,
  meta,
  timeStamp,
  type,
  active,
  iconActive = active,
  colorActive = active,
  alwaysColoured = false,
  darkText = false,
  centerIcon = false,
  busy = false,
  onOpen,
  onToggle,
  toggleLabel,
  ariaLabel,
}) => {
  const [top, bottom] = deviceColors(type, colorActive);
  const title = name && name.length > 18 ? `${name.substring(0, 18)}..` : name;
  const coloured = active || alwaysColoured;
  const classes = ["hx-card", coloured ? "is-active" : "", darkText ? "is-dark-text" : "", busy ? "is-busy" : ""];

  const icon = (
    <MdiIcon path={deviceIcon(type, iconActive)} size={52} color="currentColor" />
  );
  const details = (
    <>
      <span className="hx-card-name">{title}</span>
      {meta ? (
        <span className="hx-card-meta">{meta}</span>
      ) : floor && room ? (
        <span className="hx-card-meta">
          {floor} | {room}
        </span>
      ) : null}
      {timeStamp ? <span className="hx-card-time">{TimeAgo.getTimeAgo(timeStamp)}</span> : null}
    </>
  );

  return (
    <div className={classes.join(" ")}>
      <span
        className="hx-card-fill"
        aria-hidden="true"
        style={{ background: `linear-gradient(to bottom, ${top}, ${bottom})` }}
      />
      {onToggle ? (
        <>
          <button
            type="button"
            className={`hx-card-hit hx-card-top ${centerIcon ? "is-centered" : ""}`}
            onClick={onToggle}
            disabled={busy}
            aria-label={toggleLabel ?? `${name}, ${active ? "on" : "off"}`}
            aria-pressed={Boolean(active)}
          >
            {icon}
          </button>
          <button type="button" className="hx-card-hit hx-card-bottom" onClick={onOpen} aria-label={ariaLabel ?? `${name}. Open details`}>
            {details}
          </button>
        </>
      ) : (
        <button type="button" className="hx-card-hit is-whole" onClick={onOpen} aria-label={ariaLabel ?? `${name}. Open details`}>
          <span className={`hx-card-hit hx-card-top ${centerIcon ? "is-centered" : ""}`} style={{ width: "100%" }}>
            {icon}
          </span>
          <span className="hx-card-hit hx-card-bottom" style={{ width: "100%" }}>
            {details}
          </span>
        </button>
      )}
    </div>
  );
};

export default AppDeviceCard;
